(function () {
	'use strict';

	angular.module('dcApp').constant('validateLength', {
		maxLength: 50,
		minLength: 0,
	});

	angular.module('dcApp').constant('importStatus', {
		finished: 'FINISHED',
		running: 'RUNNING',
		canceled: 'CANCELLED',
		failed: 'FAILED',
	});

	angular.module('dcApp').directive('importModal', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				'ProjectService',
				'DataBlocksService',
				'$rootScope',
				'$stateParams',
				'$state',
				'$cookies',
				'validateLength',
				'ContextServices',
				'AppSelectorService',
				'elem',
				'API_BASE_URL_BACKEND',
				'gettextCatalog',
				'toaster',
				'importStatus',
				'APP_VERSION',
				'UserService',
				'PROJECT_PROGRESS_OPERATION',
				'PROGRESS_STATUS',
				'PROJECT_OPERATION_DONE',
				function (
					$scope,
					ProjectService,
					DataBlocksService,
					$rootScope,
					$stateParams,
					$state,
					$cookies,
					validateLength,
					ContextServices,
					AppSelectorService,
					elem,
					API_BASE_URL_BACKEND,
					gettextCatalog,
					toaster,
					importStatus,
					APP_VERSION,
					UserService,
					PROJECT_PROGRESS_OPERATION,
					PROGRESS_STATUS,
					PROJECT_OPERATION_DONE
				) {
					let execId;
					var vm = this;
					vm.descriptionTruncateThresh = 200;
					vm.descriptionTitleTruncateThresh = 400;
					vm.MAXLENGTH = validateLength.maxLength;
					vm.MINLENGTH = validateLength.minLength;
					vm.elem = elem;
					vm.closeModal = closeModal;
					vm.init = init;
					vm.projectInfos = {};
					vm.exportProjectInfos = {};
					vm.duplicatedProjectInfos = {};
					vm.importedProjectInfos = {};
					vm.confirmationData = {};
					vm.progress = {};
					vm.from = 'import';
					vm.projectStats = {};
					vm.local = true;
					vm.userExist = false;
					vm.users = [];
					vm.running = importStatus.running;
					vm.APP_VERSION = APP_VERSION;
					vm.importInProgress = false;
					vm.workDone = false;
					vm.files = {};
					vm.uploadDone = false;
					vm.importAnalysisOperation =
						PROJECT_PROGRESS_OPERATION.import_analysis;
					vm.importOperation = PROJECT_PROGRESS_OPERATION.import;
					vm.shouldMapExpositionConsumers = false;
					vm.currentStep = 'configuration'; // configuration || consumersMapping
					vm.mappingComplete = false;
					vm.firstStepValidation = {
						label: false,
						expositionRootCode: false,
						version: true,
					};
					vm.importProject = importProject;
					vm.cancelImport = cancelImport;
					vm.submitFlow = submitFlow;
					vm.uploadError = uploadError;
					vm.gotToNewProject = gotToNewProject;
					vm.handleUploadResponse = handleUploadResponse;
					vm.mappingAction = mappingAction;

					let consumersMapping = null;

					vm.showCancelConfirmation = function () {
						vm.confirmationData.confirmationDialogTitle =
							gettextCatalog.getString('cancel.import');
						vm.confirmationData.confirmationDialogMessage =
							gettextCatalog.getString('import.cancel.message');
						vm.confirmationData.confirmationDialogActionName =
							gettextCatalog.getString('yes.cancel.action');
						vm.confirmationData.cancelDialogActionName =
							gettextCatalog.getString('no.cancel.action');
						vm.confirmationData.confirmationGreenAction = false;
						vm.confirmationData.enableConfirmDialogAction = true;
						vm.confirmationData.showConfirmationDialog = true;
						vm.confirmationData.enableConfirmDialogAction = true;
						vm.confirmationData.confirmDialogAction = vm.cancelImport;
						vm.confirmationData.showConfirmationDialog = true;
					};

					vm.previousStep = function () {
						vm.currentStep = 'configuration';
					};

					vm.nextStep = function () {
						vm.currentStep = 'consumersMapping';
					};

					/**
					 *Private functions
					 */

					function init() {
						UserService.getProjectMembers($scope.active, refresh).then(
							function (response) {
								vm.users = response;
								// load contexts
								getContextsAndMarkUploadAsReady();
							}
						);
					}

					function importProject() {
						let expositionsMappings = null;
						if (
							vm.projectToImportInfos.expositionMembersToMap.length !== 0 &&
							vm.shouldMapExpositionConsumers
						) {
							expositionsMappings = Object.keys(consumersMapping).map((k) => {
								const mapping = consumersMapping[k];

								return {
									imported_member_id: +mapping.id,
									imported_is_group: mapping.isGroup,
									target_members: mapping.targetConsumers
										.toList()
										.toArray()
										.map((l) => ({
											target_member_id: l.id,
											target_is_group: l.isGroup,
										})),
								};
							});
						}

						let options = {
							project_to_update: vm.projectToImportInfos.projectToUpdate,
							folder_path: vm.projectToImportInfos.projectFolerPath,
							depot_snapshot_path: vm.projectToImportInfos.depotFilesFolderPath,
							import_permission_template:
								vm.importedProjectInfos.templateRightValue,
							metadata: {
								label: vm.importedProjectInfos.importedProjectLabel,
								description: vm.projectToImportInfos.description,
								project_version: vm.importedProjectInfos.projectVersion,
								version_description:
									vm.importedProjectInfos.projectVersionDescription,
								expiration_date: Date.parse(
									vm.importedProjectInfos.importExpirationDate
								),
								effect_date: Date.parse(
									vm.importedProjectInfos.importedEffectDate
								),
								contexts: vm.importedProjectInfos.contexts,
							},
							membership:
								vm.projectToImportInfos.members.length === 0
									? {
											new_members: vm.members,
											expositions_members_mappings: expositionsMappings,
									  }
									: {
											member_mappings: vm.members,
											expositions_members_mappings: expositionsMappings,
									  },
							elements: {
								connector: vm.elementTypes.connector.checked,
								export_template: vm.elementTypes.exportTemplate.checked,
								depot: vm.elementTypes.repository.checked,
								entity: vm.elementTypes.entity.checked,
								datablock: vm.elementTypes.datablock.checked,
								hd_element: vm.elementTypes.hdElements.checked,
								dashboard: vm.elementTypes.dashboard.checked,
								extraction: vm.elementTypes.extractRepository.checked,
								local_data: vm.elementTypes.localData.checked,
								shared_elements: vm.elementTypes.sharedElements.checked,
							},
							exposures_root_code: vm.importedProjectInfos.exposuresRootCode
								? vm.importedProjectInfos.exposuresRootCode
								: null,
							critical: vm.importedProjectInfos.critical,
							confidential: vm.importedProjectInfos.confidential,
						};

						vm.progress = {
							countOps: 12,
							projectLabel: fileName,
							operation: vm.importOperation,
							progressBarInitValue: null,
							to: vm.importedProjectInfos.importedProjectLabel,
							running: true,
						};
						$rootScope.$broadcast('bulk_status_progress', vm.progress);
						vm.importInProgress = true;

						ProjectService.importProject(options)
							.then(function (responseExp) {
								execId = responseExp.data;
								vm.progress.progressBarInitValue = 0;
								vm.progress.execId = execId;
								$rootScope.$broadcast('bulk_status_progress', vm.progress);
							})
							.catch(function (error) {
								vm.importInProgress = false;
							});
					}

					function getContextsAndMarkUploadAsReady() {
						ContextServices.getContextList(true).then(function (response) {
							delete $scope.currentContext;
							if (response.data) {
								$scope.contextList = response.data;
								delete $scope.currentContext;
								if (AppSelectorService.getSelectedCtxId() !== null) {
									for (var ctx in $scope.contextList) {
										// FIXME: possible string to number comparison
										if (
											$scope.contextList[ctx].id ==
											AppSelectorService.getSelectedCtxId()
										) {
											$scope.currentContext = $scope.contextList[ctx];
											break;
										}
									}
								}
								if (!$scope.currentContext) {
									$scope.currentContext = $scope.contextList[0];
								}

								if ($scope.currentContext) {
									setCurrentContextInLocalStorage();
								}
								if ($scope.currentContext) {
									setCurrentContextInLocalStorage();
								}
							}
							vm.uploadDone = true;
							vm.importInProgress = false;
						});
					}

					function setCurrentContextInLocalStorage() {
						AppSelectorService.setSelectedContext($scope.currentContext.id);
					}

					let fileName;
					function submitFlow(files, event, flow) {
						uploadResponseData = {};
						flow.opts.headers = {
							'Accept-Language': $rootScope.currentLangCode,
							'x-xsrf-token': $cookies.get('XSRF-TOKEN'),
						};
						flow.opts.target =
							API_BASE_URL_BACKEND +
							$rootScope.getUrl('PROJECTS_IMPORT_UPLOAD');
						flow.upload();
						fileName = files && files[0] ? files[0].name : '-';
						vm.progress = {
							countOps: 1,
							projectLabel: fileName,
							operation: vm.importAnalysisOperation,
							progressBarInitValue: null,
						};
						$rootScope.$broadcast('bulk_status_progress', vm.progress);
						vm.importInProgress = true;
					}

					function uploadError(file, response, flow) {
						let data = JSON.parse(response);
						let error =
							data.field_errors != undefined && data.field_errors.length > 0
								? data.field_errors[0]
								: data;
						if (error.field != undefined) {
							angular.forEach(vm.files.flow.files, function (fl) {
								fl.cancel();
							});
						}
						$rootScope.$broadcast('bulk_status', {
							status: PROGRESS_STATUS.failed,
						});
						vm.uploadDone = false;
					}

					let existentProjectUuid;
					let uploadResponseData = {};
					function handleUploadResponse(flow, file, response) {
						uploadResponseData = JSON.parse(response);
						if (
							!uploadResponseData.valid ||
							!uploadResponseData.valid_version
						) {
							$rootScope.$broadcast('bulk_status', {
								status: PROGRESS_STATUS.failed_version,
								version: uploadResponseData.archive_version,
							});
						} else if (
							!vm.projectToUpdateUuid &&
							uploadResponseData.project_exists &&
							uploadResponseData.existent_project_uuid
						) {
							// archive carries a uuid of an already existing project:
							// ask whether to create a new project or a new version
							existentProjectUuid = uploadResponseData.existent_project_uuid;
							showIdentifiedExistentProjectConf();
						} else {
							loadDataAfterUploadSuccess();
						}
					}

					function showIdentifiedExistentProjectConf() {
						vm.confirmationData.confirmationDialogTitle =
							gettextCatalog.getString('import.existent.project.warning.title');
						vm.confirmationData.confirmationDialogMessage =
							gettextCatalog.getString(
								'import.existent.project.warning.message'
							);
						vm.confirmationData.confirmationDialogActionName =
							gettextCatalog.getString(
								'import.existent.project.warning.action.ok'
							);
						vm.confirmationData.cancelDialogActionName =
							gettextCatalog.getString(
								'import.existent.project.warning.action.no'
							);
						vm.confirmationData.confirmationGreenAction = true;
						vm.confirmationData.enableConfirmDialogAction = true;
						// OK -> import as a new version of the existing project
						vm.confirmationData.confirmDialogAction = setUuidAndLoad;
						// No -> import as a brand new project
						vm.confirmationData.closeDialogAction = loadDataAfterUploadSuccess;
						vm.confirmationData.showConfirmationDialog = true;
					}

					function setUuidAndLoad() {
						vm.projectToUpdateUuid = existentProjectUuid;
						loadDataAfterUploadSuccess();
					}

					function loadDataAfterUploadSuccess() {
						vm.projectToImportInfos = {
							label: uploadResponseData.source_metadata.label,
							description: uploadResponseData.source_metadata.description,
							code: uploadResponseData.source_metadata.code,
							iconId: uploadResponseData.source_metadata.icon_id,
							tags: uploadResponseData.source_metadata.tags,
							archiveVersion: uploadResponseData.archive_version,
							// Numero de version du projet porte par l'archive (vide avant V3).
							projectVersion: uploadResponseData.project_version,
							// Numero de version que prendra le projet cible : seul le
							// backend sait l'incrementer, l'ecran ne fait que l'afficher.
							projectCandidateVersion: uploadResponseData.project_candidate_version,
							newProjectVersion: uploadResponseData.new_project_version,
							projectToUpdate: vm.projectToUpdateUuid,
							exportDate: moment(uploadResponseData.export_date).format(
								'DD/MM/YYYY [à] HH:MM:SS'
							),
							members: uploadResponseData.members.users.concat(
								uploadResponseData.members.groups
							),
							// DataLinks consommes dont le projet producteur est absent de la
						// plateforme : les liens resteront non resolus apres l'import.
						missingDataLinkProducers:
							uploadResponseData.missing_data_link_producers,
						missingDataLinkProducerLabels:
							uploadResponseData.missing_data_link_producer_labels || [],
						containsDepot: uploadResponseData.contains_depot_data,
							containsPermission:
								uploadResponseData.contains_permission_template,
							projectFolerPath: uploadResponseData.project_folder_path,
							validVersion: uploadResponseData.valid_version,
							validFileExtension: uploadResponseData.valid_file_extension,
							depotFilesFolderPath: uploadResponseData.depot_files_folder_path,
							expositionMembersToMap: uploadResponseData.expositions_members
								? [
										...uploadResponseData.expositions_members.users.map(
											(u) => ({
												...u,
												isGroup: false,
											})
										),
										...uploadResponseData.expositions_members.groups.map(
											(g) => ({
												...g,
												isGroup: true,
											})
										),
								  ]
								: [],
						};

						vm.importedProjectInfos.exposuresRootCode =
							uploadResponseData.exposures_root_code;
						vm.importedProjectInfos.critical =
							uploadResponseData.critical !== undefined
								? uploadResponseData.critical
								: true;
						vm.importedProjectInfos.confidential =
							uploadResponseData.confidential !== undefined
								? uploadResponseData.confidential
								: true;
						vm.projectStats = {
							connector: { count: uploadResponseData.connector_count || 0 },
							dashboard: { count: uploadResponseData.dashboard_count || 0 },
							datablock: { count: uploadResponseData.data_block_count || 0 },
							repository: { count: uploadResponseData.depot_count || 0 },
							exportTemplate: {
								count: uploadResponseData.export_template_count || 0,
							},
							entity: { count: uploadResponseData.entity_count || 0 },
							hdElements: { count: uploadResponseData.hd_element_count || 0 },
							sharedElements: {
								count:
									(uploadResponseData.exposition_count || 0) +
									(uploadResponseData.data_link_count || 0),
							}, // V2 expositions + subscriptions
						};
						// init and load users
						vm.init();
						// set label if new version
						vm.importedProjectInfos.importedProjectLabel =
							vm.projectToUpdateUuid ? vm.projectToImportInfos.label : '';
					}

					function closeModal(doNotRefresh) {
						consumersMapping = null;
						vm.mappingComplete = false;
						vm.currentStep = 'configuration';
						vm.projectInfos = {};
						vm.duplicatedProjectInfos = {};
						vm.importedProjectInfos = {};
						vm.elementTypes = {};
						vm.projectStats = {};
						vm.local = true;
						vm.userExist = false;
						vm.users = [];
						vm.data = false;
						vm.progress = {
							countOps: 1,
							projectLabel: fileName,
							operation: vm.importAnalysisOperation,
							progressBarInitValue: null,
						};
						$rootScope.$broadcast('bulk_status_progress', vm.progress);
						vm.importInProgress = false;
						vm.uploadDone = false;
						if (vm.files && vm.files.flow.files) {
							angular.forEach(vm.files.flow.files, function (fl) {
								fl.cancel();
							});
						}
						if (!doNotRefresh && vm.workDone) {
							$rootScope.$broadcast('refresh_projects_list');
						}
						vm.workDone = false;
						$(vm.element).modal('hide');
					}

					function cancelImport() {
						if (!vm.workDone && vm.projectId && execId) {
							ProjectService.cancelImportProject(vm.projectId, execId).then(
								function () {
									closeModal();
								}
							);
						} else {
							closeModal();
						}
					}

					function gotToNewProject() {
						if (vm.workDone && vm.newProjectId) {
							closeModal(true);
							$state.go('projects-edit', { projectId: vm.newProjectId });
						}
					}

					/**
					 *
					 * @param evt Record object representing ExpositionConsumerMappingEntity entity
					 */
					function mappingAction(evt) {
						if (!evt) {
							vm.mappingComplete = false;
							return;
						}
						vm.mappingComplete = true;
						consumersMapping = evt;
					}

					$scope.$on(PROJECT_OPERATION_DONE.import, function (event, data) {
						vm.workDone = true;
						vm.newProjectId = data;
					});

					$scope.$on(
						'elementToDuplicate:sharedElements:selection',
						function (evt, val) {
							if (
							val &&
							vm.projectStats.sharedElements &&
							vm.projectStats.sharedElements.count !== 0
						) {
								vm.shouldMapExpositionConsumers =
									vm.projectToImportInfos.expositionMembersToMap.length !== 0;
							} else {
								vm.shouldMapExpositionConsumers = false;
							}
						}
					);

					function updateFirstStepValidation(key, val) {
						vm.firstStepValidation = {
							...vm.firstStepValidation,
							[key]: val,
						};
						vm.firstStepIsValid = Object.keys(vm.firstStepValidation).reduce(
							(acc, curr) => {
								return acc && vm.firstStepValidation[curr];
							},
							true
						);
					}

					$scope.$on('importProjectDetails:validity', function (evt, val) {
						updateFirstStepValidation('label', val);
					});
					$scope.$on(
						'importProjectDetails:validity:rootCode',
						function (evt, val) {
							updateFirstStepValidation('expositionRootCode', val);
						}
					);
					$scope.$on('projectVersion:validity:unique', function (evt, val) {
						updateFirstStepValidation('version', val);
					});
				},
			];
			return buildDirectiveReturnObject(
				{ projectId: '=', data: '=', projectToUpdateUuid: '=' },
				controller,
				'./src/components/directives/importProject/importProjectModal.html',
				function postLink(scope, element, attrs) {
					initElementForDirective(element, attrs, function () {
						scope.vm.data = false;
					});
					watchElementForDirective(
						element,
						scope,
						function () {
							return scope.vm.data;
						},
						function () {},
						false
					);
				}
			);
		},
	]);
})();
